import { createContext, useContext, useEffect, useMemo, useState } from 'react'
import { getStoredAuth, clearStoredAuth } from './storage'
import { applyAuthHeaders, setForcedLogoutHandler } from '../api/http'
import * as authApi from '../api/auth'
import { hasPermission } from './permissions'

const AuthContext = createContext(null)

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(() => getStoredAuth())

  useEffect(() => {
    // si el interceptor fuerza logout (refresh falló), limpiamos el estado
    setForcedLogoutHandler(() => {
      clearStoredAuth()
      applyAuthHeaders(null)
      setAuth(null)
    })
  }, [])

  const value = useMemo(
    () => ({
      auth,
      isAuthenticated: !!auth?.accessToken,
      async login(username, password) {
        const next = await authApi.login(username, password)
        setAuth(next)
        return next
      },
      async logout() {
        await authApi.logout()
        setAuth(null)
      },
      can: (perm) => hasPermission(auth?.permissions, perm),
    }),
    [auth],
  )

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth debe usarse dentro de <AuthProvider>')
  return ctx
}
